module.exports = __webpack_public_path__ + "img/answer_2.615c0531.png";